module.exports = __webpack_public_path__ + "img/sac-home.8720d447.jpg";